/* global SideDrawer */

if (!customElements.get('facet-filters')) {
  class FacetFilters extends SideDrawer {
    constructor() {
      super();
      this.filteringEnabled = this.dataset.filtering === 'true';
      this.sortingEnabled = this.dataset.sorting === 'true';
      this.results = document.getElementById('filter-results');

      if ((!this.filteringEnabled && !this.sortingEnabled) || !this.results) return;
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.resultsCountEl = document.getElementById('results-count');
      this.form = document.getElementById('facets');
      this.bindToolbarEvents();

      if (this.filteringEnabled) {
        this.filters = this.querySelector('.facets__filters');
        this.activeFilters = document.querySelector('.active-filters');
        this.footer = this.querySelector('.facets__footer');
        this.filtersOpen = this.dataset.filtersOpen;

        this.filters.addEventListener('click', this.handleFiltersClick.bind(this));
        this.filters.addEventListener('input', window.debounce(this.handleFilterChange.bind(this), 300));
      }

      if (this.sortingEnabled) {
        this.desktopSortBy = document.getElementById('sort-by');
        this.headerSortBy = document.getElementById('sort-by-dropdown');
      }

      window.addEventListener('popstate', this.handleHistoryChange.bind(this));
      window.addEventListener('on:debounced-resize', this.handleWindowResize.bind(this));

      this.handleWindowResize();
    }



    bindToolbarEvents() {
      if (this.filteringEnabled) {
        this.showFiltersBtn = document.querySelector('.js-show-filters');
        this.showBrandBtn = document.querySelector('.js-show-brand-filter');
        this.activeFilters = document.querySelector('.active-filters');

        if (this.showFiltersBtn) this.showFiltersBtn.onclick = this.showFilters.bind(this);
        if (this.showBrandBtn) this.showBrandBtn.onclick = this.showBrandFilter.bind(this);
        if (this.activeFilters) this.activeFilters.onclick = this.handleActiveFiltersClick.bind(this);
      }

      if (this.sortingEnabled) {
        this.showSortBtn = document.querySelector('.js-show-sort');
        this.desktopSortBy = document.getElementById('sort-by');
        this.headerSortBy = document.getElementById('sort-by-dropdown');

        if (this.desktopSortBy) this.desktopSortBy.onchange = this.handleFilterChange.bind(this);
        if (this.headerSortBy) this.headerSortBy.onchange = this.handleHeaderSortChange.bind(this);
        if (this.showSortBtn) this.showSortBtn.onclick = this.showSort.bind(this);
      }

      document.querySelectorAll('.results-dropdown__menu a, .js-reset-filters').forEach((link) => {
        link.onclick = this.handleToolbarLinkClick.bind(this);
      });

      document.querySelectorAll('.results-dropdown > summary, .results-header__action--filter').forEach((trigger) => {
        trigger.onpointerdown = () => {
          trigger.classList.remove('is-tapped');
          window.requestAnimationFrame(() => trigger.classList.add('is-tapped'));
          window.setTimeout(() => trigger.classList.remove('is-tapped'), 220);
        };
      });

      document.querySelectorAll('.results-dropdown > summary').forEach((summary) => {
        summary.onclick = () => {
          const details = summary.parentElement;
          if (!details) return;
          document.querySelectorAll('.results-dropdown[open]').forEach((openDropdown) => {
            if (openDropdown !== details) openDropdown.open = false;
          });
        };
      });
    }

    handleToolbarLinkClick(evt) {
      const link = evt.currentTarget;
      if (!link) return;
      evt.preventDefault();

      if (link.dataset.sortValue) {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', link.dataset.sortValue);
        this.applyFilters(params.toString());
      } else if (link.href) {
        const url = new URL(link.href, window.location.origin);
        this.applyFilters(url.searchParams.toString());
      }

      const parentDetails = link.closest('details');
      if (parentDetails) parentDetails.open = false;
    }

    /**
     * Opens the filters drawer.
     */
    showFilters() {
      const sortDrawer = this.querySelector('#drawer-sort-by');
      if (sortDrawer) sortDrawer.open = false;
      this.open(this.showFiltersBtn);
    }

    /**
     * Opens the filters drawer with sort expanded.
     */
    showSort() {
      const sortDrawer = this.querySelector('#drawer-sort-by');
      this.open(this.showSortBtn || this.showFiltersBtn);
      if (sortDrawer) sortDrawer.open = true;
    }

    showBrandFilter() {
      const sortDrawer = this.querySelector('#drawer-sort-by');
      if (sortDrawer) sortDrawer.open = false;
      this.open(this.showBrandBtn || this.showFiltersBtn);
      const vendorFilter = this.querySelector('[id*="filter-details-filter\.v\.vendor"]');
      if (vendorFilter) vendorFilter.open = true;
    }


    handleHeaderSortChange(evt) {
      this.handleFilterChange(evt);
    }

    /**
     * Handles 'input' events on the filters and 'change' events on the sort by dropdown.
     * @param {object} evt - Event object.
     */
    handleFilterChange(evt) {
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const emptyParams = [];

      if (this.sortingEnabled) {
        // Sync selected values of mobile and desktop sort inputs.
        if (evt.target === this.desktopSortBy || evt.target === this.headerSortBy) {
          const sortValue = evt.target.value;
          if (this.desktopSortBy) this.desktopSortBy.value = sortValue;
          if (this.headerSortBy) this.headerSortBy.value = sortValue;
          const mobileSortBy = this.querySelector(`#drawer-sort-by input[name="sort_by"][value="${sortValue}"]`);
          if (mobileSortBy) mobileSortBy.checked = true;
        } else if (evt.target.name === 'sort_by') {
          if (this.desktopSortBy) this.desktopSortBy.value = evt.target.value;
          if (this.headerSortBy) this.headerSortBy.value = evt.target.value;
        }

        // Remove duplicate 'sort_by' parameters.
        const sortValue = (this.headerSortBy && this.headerSortBy.value) || (this.desktopSortBy && this.desktopSortBy.value) || '';
        searchParams.set('sort_by', sortValue);
      }

      // Get empty parameters.
      searchParams.forEach((value, key) => {
        if (!value) emptyParams.push(key);
      });

      // Remove empty parameters.
      emptyParams.forEach((key) => {
        searchParams.delete(key);
      });

      this.applyFilters(searchParams.toString());
    }

    /**
     * Handles 'click' events on the filters.
     * @param {object} evt - Event object.
     */
    handleFiltersClick(evt) {
      const { target } = evt;

      // Filter 'clear' button clicked.
      if (target.matches('.js-clear-filter')) {
        evt.preventDefault();
        this.applyFilters(new URL(evt.target.href).searchParams.toString());
      }

      // Filter 'show more' button clicked.
      if (target.matches('.js-show-more')) {
        const filter = target.closest('.filter');
        target.remove();

        filter.querySelectorAll('li').forEach((el) => {
          el.classList.remove('js-hidden');
        });
      }
    }

    /**
     * Handles 'click' events on the active filters.
     * @param {object} evt - Event object.
     */
    handleActiveFiltersClick(evt) {
      const link = evt.target.closest('a');
      if (!link) return;
      evt.preventDefault();
      this.applyFilters(new URL(link.href).searchParams.toString());
    }

    /**
     * Handles history changes (e.g. back button clicked).
     * @param {object} evt - Event object.
     */
    handleHistoryChange(evt) {
      let searchParams = '';

      if (evt.state && evt.state.searchParams) {
        ({ searchParams } = evt.state);
      }

      this.applyFilters(searchParams, false);
    }

    /**
     * Handles debounced 'resize' events on the window.
     */
    handleWindowResize() {
      if (!theme.mediaMatches.md) {
        this.querySelectorAll('.filter').forEach((el) => {
          el.open = false;
          el.classList.remove('is-open');
        });
      } else {
        this.querySelectorAll('.filter').forEach((el, index) => {
          if (this.filtersOpen === 'all' || (this.filtersOpen === 'some' && index < 5)) {
            el.open = true;
            el.classList.add('is-open');
          }
        });
      }
    }

    /**
     * Fetches the filtered/sorted page data and updates the current page.
     * @param {string} searchParams - Filter/sort search parameters.
     * @param {boolean} [updateUrl=true] - Update url with the selected options.
     */
    async applyFilters(searchParams, updateUrl = true) {
      this.results.classList.add('is-loading');

      // Fetch filtered products markup.
      const response = await fetch(`${window.location.pathname}?${searchParams}`);

      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        // Update the filters and toolbar.
        if (this.filteringEnabled) this.updateFilters(tmpl.content);
        this.updateToolbar(tmpl.content);

        // Update the results.
        this.results.innerHTML = tmpl.content.getElementById('filter-results').innerHTML;
        window.initLazyMedia?.(this.results);

        // Update the URL.
        if (updateUrl) FacetFilters.updateURL(searchParams);
      }

      this.results.classList.remove('is-loading');
    }



    updateToolbar(html) {
      const currentHeader = document.querySelector('.results-header');
      const newHeader = html.querySelector('.results-header');

      if (!currentHeader || !newHeader) return;

      currentHeader.innerHTML = newHeader.innerHTML;
      this.resultsCountEl = document.getElementById('results-count');
      this.bindToolbarEvents();
    }

    /**
     * Updates the filters with the fetched data.
     * @param {string} html - HTML of the fetched document.
     */
    updateFilters(html) {
      // Save current focus
      const currentFocusId = document.activeElement ? document.activeElement.id : null;

      // Save open filters
      const openedFilterIDs = [];
      this.querySelectorAll('.filter[open]').forEach((el) => openedFilterIDs.push(el.id));

      // Update filters
      this.filters.innerHTML = html.querySelector('.facets__filters').innerHTML;

      // Restore open filters
      openedFilterIDs.forEach((id) => {
        this.querySelectorAll(`#${CSS.escape(id)}`).forEach((el) => { el.open = true; });
      });

      // Preserve focus
      if (currentFocusId) {
        const focusEl = this.filters.querySelector(`#${CSS.escape(currentFocusId)}`);
        if (focusEl) focusEl.focus();
      }

      // Update total
      this.updateResultsTotal(html);

      // Update active filters.
      this.updateActiveFilters(html);

      // Update '[x] results' button (mobile only).
      const footerEl = html.querySelector('.facets__footer');
      this.footer.innerHTML = footerEl.innerHTML;
    }

    /**
     * Updates the result count.
     * @param {string} html - HTML of the fetched page.
     */
    updateResultsTotal(html) {
      if (this.resultsCountEl) {
        this.resultsCountEl.innerHTML = html.querySelector('#results-count').innerHTML;
      }
    }

    /**
     * Updates the active filters.
     * @param {string} html - HTML of the fetched page.
     */
    updateActiveFilters(html) {
      this.activeFilters.innerHTML = html.querySelector('.active-filters').innerHTML;
      this.activeFilters.hidden = !this.activeFilters.querySelector('.active-filters__item');
    }

    /**
     * Updates the url with the current filter/sort parameters.
     * @param {string} searchParams - Filter/sort parameters.
     */
    static updateURL(searchParams) {
      window.history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  }

  customElements.define('facet-filters', FacetFilters);
}
